import { useNavigate, useLocation } from "react-router-dom";
import { LogOut, MessageSquareHeart, Music2, Users } from "lucide-react";
import { ownerApi } from "@/lib/ownerApi";

const LINKS = [
  ["/admin", "Families", Users, "admin-nav-families"],
  ["/admin/notes", "Notes", MessageSquareHeart, "admin-nav-notes"],
  ["/", "Music", Music2, "admin-music-link"],
];

export default function AdminNav() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const signOut = async () => { await ownerApi.post("/auth/logout").catch(() => {}); navigate("/"); };
  return (
    <nav className="flex items-center gap-0.5">
      {LINKS.map(([href, label, Icon, id]) => (
        <a key={href} href={href} data-testid={id} aria-label={label}
           className={`text-xs inline-flex items-center gap-1.5 px-2.5 sm:px-3 py-2 rounded-full whitespace-nowrap ${pathname === href ? "text-[#D4AF37]" : "text-[#A0988E] hover:text-[#F5F0E8]"}`}>
          <Icon size={14} /> <span className="hidden sm:inline">{label}</span>
        </a>
      ))}
      <button data-testid="admin-sign-out-button" onClick={signOut} aria-label="Sign out" className="text-[#A0988E] hover:text-[#F5F0E8] p-2"><LogOut size={14} /></button>
    </nav>
  );
}
